import {Table} from "antd";
import React from "react";

const StatsTable = ({ data }) => {
  // Transform the data into the format expected by antd Table
  const transformData = () => {
    if (!data) return [];

    return Object.entries(data)
      .filter(([period]) => [252, 512, 756].includes(parseInt(period)))
      .map(([period, stats]) => {
        // Ensure stats object exists
        if (!stats) return {
          key: period,
          period,
          pct_r: '-',
          pct_a: '-',
          sharpe: '-',
          hv: '-'
        };

        return {
          key: period,
          period: `${period}`,
          pct_r: stats.pct_r ? (stats.pct_r * 100).toFixed(2) : '-',
          pct_a: stats.pct_a ? (stats.pct_a * 100).toFixed(2) : '-',
          sharpe: stats.sharpe ? stats.sharpe.toFixed(2) : '-',
          hv: stats.hv ? (stats.hv * 100).toFixed(2) : '-',
        };
      });
  };
  const periodMap = {
      252: '1 Year',
      512: '2 Years',
      756: '3 Years',
  }

  const columns = [
    {
      title: 'Period',
      dataIndex: 'period',
      key: 'period',
      sorter: (a, b) => parseInt(a.period) - parseInt(b.period),
      render: (text) => <span className={'text-gray-600'}>{periodMap[text]}</span>,
    },
    {
      title: 'Return (%)',
      dataIndex: 'pct_r',
      key: 'pct_r',
      sorter: (a, b) => {
        const numA = parseFloat(a.pct_r);
        const numB = parseFloat(b.pct_r);
        if (isNaN(numA) || isNaN(numB)) return 0;
        return numA - numB;
      },
      render: (text) => <span className={'font-medium'}>{text}</span>,
    },
    {
      title: 'Annualized (%)',
      dataIndex: 'pct_a',
      key: 'pct_a',
      sorter: (a, b) => {
        const numA = parseFloat(a.pct_a);
        const numB = parseFloat(b.pct_a);
        if (isNaN(numA) || isNaN(numB)) return 0;
        return numA - numB;
      },
      render: (text) => <span className={'font-medium'}>{text}</span>,
    },
    {
      title: 'Sharpe',
      dataIndex: 'sharpe',
      key: 'sharpe',
      sorter: (a, b) => {
        const numA = parseFloat(a.sharpe);
        const numB = parseFloat(b.sharpe);
        if (isNaN(numA) || isNaN(numB)) return 0;
        return numA - numB;
      },
      render: (text) => <span className={'font-medium'}>{text}</span>,
    },
    {
      title: 'Historical Vol (%)',
      dataIndex: 'hv',
      key: 'hv',
      sorter: (a, b) => {
        const numA = parseFloat(a.hv);
        const numB = parseFloat(b.hv);
        if (isNaN(numA) || isNaN(numB)) return 0;
        return numA - numB;
      },
      render: (text) => <span className={'font-medium'}>{text}</span>,
    },
  ];

  return (
    <Table
      dataSource={transformData()}
      columns={columns}
      pagination={false}
      style={{
        backgroundColor: 'white',
      }}
    />
  );
};


export default StatsTable;